<template>
    <div class="row recent-orders">
        <div class="col-md-12">
            <div class="row">
                <div class="col-sm-12 col-md-6">
                    <div class="d-flex align-items-center">
                        <h3>Available Inventory</h3>
                        <span class="pl-3">Last Updated: {{ latestDate }}</span>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3 pb-2">
                    <div class="row align-items-center">
                        <div class="col-md-4">
                            <label
                                class="form-control-label text-muted"
                                for="filter_status"
                                >Filter by Category:
                            </label>
                        </div>
                        <div class="col-md-8">
                            <select
                                id="filter_status"
                                class="form-control"
                                v-model="searchStatus"
                            >
                                <option value="all">ALL</option>
                                <template
                                    v-for="(
                                        category, idx
                                    ) in categoriesFromInventories"
                                    :key="idx"
                                >
                                    <option :value="category">
                                        {{ category }}
                                    </option>
                                </template>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="col-sm-12 col-md-3 text-right">
                    <div class="form-group">
                        <div class="input-group search-field">
                            <input
                                class="form-control"
                                type="text"
                                placeholder="Search Available Inventory"
                                v-model="searchTerm"
                                autocomplete="off"
                            />
                            <div class="input-group-prepend">
                                <span class="input-group-text"
                                    ><i class="fas fa-search"></i
                                ></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <table
                class="table table-responsive table-striped border-bottom mt-2"
            >
                <thead class="thead-light">
                    <tr>
                        <th
                            @click="sort('sku')"
                            class="cursor-pointer-with-hover"
                        >
                            SKU
                        </th>
                        <th
                            @click="sort('product_name')"
                            class="cursor-pointer-with-hover"
                        >
                            Name
                        </th>
                        <th>Category</th>
                        <th
                            @click="sort('quantity_on_hand_sico_stock')"
                            class="text-right cursor-pointer-with-hover"
                        >
                            Available Qty
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="inventory in paginatedInventories"
                        :key="inventory.id"
                    >
                        <td>{{ inventory.sku }}</td>
                        <td>{{ inventory.product_name }}</td>
                        <td>{{ inventory.product_category }}</td>
                        <td class="text-right">
                            {{
                                inventory.quantity_on_hand_sico_stock < 0
                                    ? 0
                                    : inventory.quantity_on_hand_sico_stock
                            }}
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- Pagination -->
            <table-pagination
                ref="childComponent"
                v-model="paginatedInventories"
                :all-rows="searchAllInventoriesbyTerm"
                :perPage="perPage"
                :curr-sort="currentSort"
                @updateRow="updateRow"
            >
            </table-pagination>
        </div>
    </div>
</template>

<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import TablePagination from "@/components/TablePagination.vue";

export default {
    props: [],
    emits: [],
    components: {
        TablePagination,
    },
    setup() {
        const store = useStore();

        let user = computed(function () {
            return store.state.user;
        });

        let categoriesFromInventories = computed(function () {
            return store.state["availableInventory"].categoriesFromInventories;
        });

        let allAvailableInventories = computed(function () {
            return store.state["availableInventory"].allAvailableInventories;
        });

        let latestDate = computed(function () {
            return store.state["availableInventory"].latestDate;
        });

        onMounted(() => {});

        return {
            store,
            user,
            categoriesFromInventories,
            allAvailableInventories,
            latestDate,
        };
    },
    data() {
        return {
            paginatedInventories: [],
            perPage: 50,
            searchTerm: "",
            searchStatus: "all",
            filterShow: false,
            currentSort: "product_name",
            currentSortDir: "asc",
        };
    },
    computed: {
        searchAllInventoriesbyTerm() {
            if (this.searchTerm === "" && this.searchStatus === "all") {
                return this.allAvailableInventories;
            }

            var filterArr = [];
            var filterArr2 = [];
            var result = [];

            if (this.searchStatus !== "all") {
                this.allAvailableInventories.forEach((inventory) => {
                    if (
                        inventory.product_category &&
                        inventory.product_category
                            .toLowerCase()
                            .includes(this.searchStatus.toLowerCase())
                    ) {
                        filterArr.push(inventory);
                    }
                });
            }

            if (this.searchTerm !== "") {
                this.allAvailableInventories.forEach((inventory) => {
                    if (
                        (inventory.sku &&
                            inventory.sku
                                .toLowerCase()
                                .includes(this.searchTerm.toLowerCase())) ||
                        (inventory.product_name &&
                            inventory.product_name
                                .toLowerCase()
                                .includes(this.searchTerm.toLowerCase()))
                    ) {
                        filterArr2.push(inventory);
                    }
                });
            }

            if (this.searchStatus !== "all" && this.searchTerm !== "") {
                result = filterArr.filter(
                    (c) => filterArr2.findIndex((x) => x.id == c.id) > -1
                );
            } else if (this.searchStatus !== "all" && this.searchTerm === "") {
                result = filterArr;
            } else if (this.searchStatus === "all" && this.searchTerm !== "") {
                result = filterArr2;
            }

            return result;
        },
        sortInventories() {
            return this.searchAllInventoriesbyTerm.sort((a, b) => {
                let modifier = 1;
                if (this.currentSortDir === "desc") modifier = -1;
                if (a[this.currentSort] < b[this.currentSort])
                    return -1 * modifier;
                if (a[this.currentSort] > b[this.currentSort])
                    return 1 * modifier;
                return 0;
            });
        },
    },
    mounted() {
        this.store
            .dispatch("availableInventory/getCategoriesFromInventories")
            .then((resp) => {
                this.store.dispatch(
                    "availableInventory/getAllAvailableInventories"
                );
            });
    },
    methods: {
        updateRow(val) {
            this.paginatedInventories = val;
        },
        sort(s) {
            //if s == current sort, reverse
            if (s === this.currentSort) {
                this.currentSortDir =
                    this.currentSortDir === "asc" ? "desc" : "asc";
            }
            this.currentSort = s;

            this.$refs.childComponent.sort(
                this.currentSort,
                this.currentSortDir
            );

            // console.log(
            //     "s",
            //     s,
            //     "currentSort",
            //     this.currentSort,
            //     "currentSortDir",
            //     this.currentSortDir,
            //     this.searchAllInventoriesbyTerm
            // );
        },
    },
};
</script>
